import React from 'react';
import { Grid, TextField, Paper } from '@material-ui/core';
import { LabelValueCard } from '../../../shared_elements';
const LesseeInfo = ({invoiceInfo, mode, onFieldChange, updateErrorField, error}) => {
  return(
    <Grid item xs={12} md={6}>
      <Paper className={`lessor-lessee-info ${mode === 'view' ? 'lessor-lessee-view':'lessor-lessee-edit'}`}>
        <h4>To (Lessee)</h4>
        <Grid container spacing={2}>
          { mode === 'view' ?
            <LabelValueCard md={12} label='Name' value={invoiceInfo.to_company_name ? invoiceInfo.to_company_name:'--'} />
            :
            <Grid item xs={12}>
              <TextField
                id="to_company_name"
                label="Name"
                fullWidth
                margin="normal"
                value={invoiceInfo.to_company_name}
                InputLabelProps={{shrink: true}}
                inputProps={{ maxLength: 50 }}
                error={error.to_company_name ? true:false}
                helperText={error.to_company_name ? error.to_company_name:''}
                onChange={(e) => onFieldChange(e, 'to_company_name', e.target.value)}
                onFocus={() => updateErrorField('to_company_name','')}
              />
            </Grid>
          }
          { mode === 'view' ?
            <LabelValueCard md={12} label='Address' value={invoiceInfo.to_company_address ? invoiceInfo.to_company_address:'--'} />
            :
            <Grid item xs={12}>
              <TextField
                id="to_company_address"
                label="Address"
                fullWidth
                margin="normal"
                multiline
                rows="4"
                value={invoiceInfo.to_company_address}
                InputLabelProps={{shrink: true}}
                inputProps={{ maxLength: 100 }}
                onChange={(e) => onFieldChange(e, 'to_company_address', e.target.value)}
              />
            </Grid>
          }
          { mode === 'view' ?
            <LabelValueCard md={12} label='Contact' value={invoiceInfo.to_company_contact ? invoiceInfo.to_company_contact:'--'} />
            :
            <Grid item xs={12}>
              <TextField
                id="to_company_contact"
                label="Contact (Email and Phone)"
                fullWidth
                margin="normal"
                value={invoiceInfo.to_company_contact}
                InputLabelProps={{shrink: true}}
                inputProps={{ maxLength: 100 }}
                onChange={(e) => onFieldChange(e, 'to_company_contact', e.target.value)}
              />
            </Grid>
          }
        </Grid>
      </Paper>
    </Grid>
  )
}
export default LesseeInfo;
